export default __webpack_public_path__ + "static/media/white-tick.1a42b8e8.svg";